import axios from "axios";


//pass new generated access token here


//apply base url for axios
const API_URL = "https://testrsapi.realtyspacehub.com/api/";
//const API_URL = "https://rscoreapi.azurewebsites.net/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
   headers: {
    "Content-Type": "application/json",
    //"Access-Control-Allow-Origin": "*",
  },
});



axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  const response = await axiosApi.get(url, config);
  return response.data;
}

export async function post(url, data, config = {}) {
  const response = await axiosApi.post(url, data, config);
  return response.data;
}

export async function put(url, data, config = {}) {
  const response = await axiosApi.put(url, data, config);
  return response.data;
}

export async function del(url, config = {}) {
  const response = await axiosApi.delete(url, config);
  return response.data;
}
